// extracted by mini-css-extract-plugin
module.exports = {"card":"generic-card_card__1A_kO","card-selected":"generic-card_card-selected__22D1w"};